import * as React from "react";
import { makeStyles } from "@material-ui/styles";
import Link from "@material-ui/core/Link";
import Typography from "@material-ui/core/Typography";
import clsx from "clsx";
const useStyles = makeStyles(({
  typography,
  breakpoints
}) => ({
  mainWrapper: {
    display: "flex",
    justifyContent: "space-between",
    alignItems: "center",
    marginRight: typography.pxToRem(15),
    marginLeft: typography.pxToRem(15)
  },
  title: {
    fontSize: typography.pxToRem(19),
    fontWeight: 300,
    lineHeight: 1.68,
    letterSpacing: 0.4,
    textAlign: "center",
    color: "#b7b9bd",
    marginRight: typography.pxToRem(20),
    [breakpoints.down("xs")]: {
      fontSize: typography.pxToRem(15)
    }
  },
  button: {
    color: "#1d9ad0",
    fontSize: typography.pxToRem(13),
    fontWeight: "normal",
    fontStretch: "normal",
    fontStyle: "normal",
    lineHeight: "normal",
    letterSpacing: 0.44,
    textAlign: "center",
    cursor: "pointer",
    [breakpoints.down("xs")]: {
      fontSize: typography.pxToRem(11)
    }
  }
}));

const HeadingWithAction = ({
  title,
  buttonText,
  onClick = () => undefined,
  titleClassName,
  testId
}) => {
  const styles = useStyles();
  return /*#__PURE__*/React.createElement("div", {
    className: styles.mainWrapper
  }, /*#__PURE__*/React.createElement(Typography, {
    className: clsx(styles.title, titleClassName),
    "data-testid": `${testId || "heading-with-action"}-title`
  }, title), /*#__PURE__*/React.createElement(Link, {
    component: "button",
    onClick: () => onClick(),
    className: styles.button,
    "data-testid": `${testId || "heading-with-action"}-button`
  }, buttonText));
};

export default HeadingWithAction;